import { render, staticRenderFns } from "./@popup_detail.vue?vue&type=template&id=1f4b0550&scoped=true&"
import script from "./@popup_detail.vue?vue&type=script&lang=js&"
export * from "./@popup_detail.vue?vue&type=script&lang=js&"
import style0 from "./@popup_detail.vue?vue&type=style&index=0&id=1f4b0550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b0550",
  null
  
)

export default component.exports